document.addEventListener('DOMContentLoaded', () => {
    const contactModalEnablers = document.querySelectorAll('.contact-modal-enabler');
    const closeModalButtons = document.querySelectorAll('.modal .icon-close');
    const contactForm = document.querySelector('#contact-form-content');
    contactModalEnablers.forEach((enabler) => {
        enabler.addEventListener('click', () => {
            const modal = document.querySelector('#contact-modal');
            const body = document.querySelector('body');
            if (modal) {
                modal.setAttribute('button-text', enabler.textContent.trim());
                body.classList.add('modal-open');
                modal.setAttribute('aria-hidden', 'false');
                modal.classList.add('active');
                document.body.classList.add('modal-open');
                const closeBtn = modal.querySelector('.modal-close');
                closeBtn.addEventListener('click', () => {
                    modal.classList.remove('active');
                    document.body.classList.remove('modal-open');
                    body.classList.remove('modal-open');
                    modal.setAttribute('aria-hidden', 'true');
                });
            }
        });
    });
    closeModalButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const modal = button.closest('.modal');
            if (modal) {
                modal.classList.remove('active');
                document.body.classList.remove('modal-open');
                modal.setAttribute('aria-hidden', 'true');
                const body = document.querySelector('body');
                body.classList.remove('modal-open');
            }
        });
    });
    if (contactForm) {
        const contactName = contactForm.querySelector('#contact-name');
        const contactNameFeedback = contactForm.querySelector('#contact-name + .form-message');
        const contactEmail = contactForm.querySelector('#contact-email');
        const contactEmailFeedback = contactForm.querySelector('#contact-email + .form-message');
        const contactMessage = contactForm.querySelector('#contact-message');
        const contactMessageFeedback = contactForm.querySelector('#contact-message + .form-message');
        const contactSubmit = contactForm.querySelector('#contact-submit');
        if (contactSubmit) {
            contactSubmit.addEventListener('click', async (e) => {
                e.preventDefault();
                let valid = true;

                if (!contactName.value.trim()) {
                    contactNameFeedback.textContent = 'Podaj swoje imię.';
                    valid = false;
                } else {
                    contactNameFeedback.textContent = '';
                }

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(contactEmail.value.trim())) {
                    contactEmailFeedback.textContent = 'Wpisz poprawny adres e-mail.';
                    valid = false;
                } else {
                    contactEmailFeedback.textContent = '';
                }

                if (!contactMessage.value.trim()) {
                    contactMessageFeedback.textContent = 'Wpisz swoją wiadomość.';
                    valid = false;
                } else {
                    contactMessageFeedback.textContent = '';
                }

                if (!valid) return;

                contactSubmit.disabled = true;
                try {
                    const response = await fetch('/api/poll/email', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            name: contactName.value.trim(),
                            email: contactEmail.value.trim(),
                            message: contactMessage.value.trim(),
                        }),
                    });
                    if (response.ok) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'contact_form_submitted',
                            user_email: contactEmail.value.trim() || '',
                            link_click: document.querySelector('#contact-modal').getAttribute('button-text') || '',
                        });
                        alert('Dziękujemy za kontakt! Odpowiemy najszybciej jak to możliwe.');
                        contactForm.reset();
                    } else {
                        alert('Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie później.');
                    }
                } catch (err) {
                    alert('Nie udało się połączyć z serwerem. Spróbuj ponownie później.');
                } finally {
                    contactSubmit.disabled = false;
                }
            });
        }
    }
});